import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface RemovalModalData {
  fileName: string;
  fileType?: string;
}

@Component({
  selector: 'ui-removal-modal',
  templateUrl: './removal-modal.component.html',
  styleUrls: ['./removal-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RemovalModalComponent {
  constructor(
    private _dialogRef: MatDialogRef<RemovalModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RemovalModalData,
  ) {}

  public closeModal(event: Event, result: boolean): void {
    event.preventDefault();

    this._dialogRef.close(result);
  }
}
